import { Program } from "@/pages/LedReminder/types.ts";

interface ProgramCardProps {
  program: Program;
  onClick: (event: React.MouseEvent) => void;
}

export const ProgramCard = ({ program, onClick }: ProgramCardProps) => {
  // Fonction pour convertir le jour numérique en nom
  const getDayName = (dayNum: string) => {
    const days = {
      "0": "Dimanche",
      "1": "Lundi",
      "2": "Mardi",
      "3": "Mercredi",
      "4": "Jeudi",
      "5": "Vendredi",
      "6": "Samedi",
    };
    return days[dayNum as keyof typeof days] || "?";
  };

  return (
    <div
      className="card bg-base-100 shadow-lg cursor-pointer hover:shadow-xl transition-shadow"
      onClick={onClick}
    >
      <div className="card-body p-4">
        <div className="flex justify-between items-center">
          <h2 className="card-title text-lg">{program.name}</h2>
          <div
            className={`badge ${
              program.active ? "badge-success" : "badge-error"
            }`}
          >
            {program.active ? "Actif" : "Inactif"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-2 text-sm">
          <div className="flex items-center">
            <span className="font-medium mr-1">Mode:</span>
            <span>{program.mode}</span>
          </div>

          <div className="flex items-center">
            <span className="font-medium mr-1">Couleur:</span>
            <div
              className="w-4 h-4 rounded-full border border-gray-300"
              style={{ backgroundColor: program.color }}
            />
          </div>

          <div className="col-span-2 divider my-1"></div>

          <div className="col-span-2">
            <span className="font-medium">Allumage:</span>
            <div className="flex justify-between ml-2">
              <span>{getDayName(program.startDay)}</span>
              <span>{program.startTime}</span>
            </div>
          </div>

          <div className="col-span-2">
            <span className="font-medium">Extinction:</span>
            <div className="flex justify-between ml-2">
              <span>{getDayName(program.stopDay)}</span>
              <span>{program.stopTime}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
